"use client";

import { useEffect } from 'react';
import { useData } from '@/components/data-provider';
import { useTranslation } from './provider';
import { Locale, locales } from './index';

/**
 * Syncs the user's locale preference from the database to the i18n provider.
 * Must be placed inside both I18nProvider and DataProvider.
 */
export function LocaleSync() {
    const { user } = useData();
    const { setLocale, locale } = useTranslation();

    useEffect(() => {
        if (user?.locale && locales.includes(user.locale as Locale) && user.locale !== locale) {
            setLocale(user.locale as Locale);
        }
    }, [user?.locale, setLocale, locale]);

    return null;
}
